/**
 * CUS-SKU-Stock custom element
 * Listens for Horizon's variant:update event and refreshes inventory + SKU display.
 * Uses Section Rendering API HTML (event.detail.data.html) for server-side accuracy.
 */
(function () {
  if (customElements.get('cus-sku-stock')) return;

  class CusSkuStock extends HTMLElement {
    connectedCallback() {
      this._section = this.closest('.shopify-section, dialog');
      if (this._section) {
        this._section.addEventListener('variant:update', this._onVariantUpdate);
      }
    }

    disconnectedCallback() {
      if (this._section) {
        this._section.removeEventListener('variant:update', this._onVariantUpdate);
      }
    }

    _onVariantUpdate = (event) => {
      var detail = event.detail;

      if (detail.data.newProduct) {
        this.dataset.productId = detail.data.newProduct.id;
      } else if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      var newEl = detail.data.html.querySelector('cus-sku-stock');
      if (!newEl) return;
      this.innerHTML = newEl.innerHTML;
    };
  }

  customElements.define('cus-sku-stock', CusSkuStock);
})();
